import BigNumber from "bignumber.js";

export const displayBigNumber = (bn: BigNumber, decimals: number) => {
  const num = bn.div(10 ** decimals).toNumber();
  // @ts-ignore
  const result = num.toLocaleString("en-US", { minimumFractionDigits: 2 });

  return result;
};
